import { useCallback, useMemo, useReducer } from 'react'
import { filesLabel, getActualSize } from 'Helpers'
import {
	prepareFileDescr,
	ViewIcons,
	ReducerCallback,
	UseViewParamsProps,
	ViewState,
} from 'Modules'

export const useViewParams = ({
	title,
	maxFileSize,
	acceptedFiles,
	maxFilesCount,
}: UseViewParamsProps) => {
	const initialParams = useMemo<ViewState>(
		() => ({
			viewTooltip: prepareFileDescr([
				maxFilesCount > 1 ? `До ${maxFilesCount} ${filesLabel(maxFilesCount)}` : `Один файл`,
				`${maxFilesCount > 1 ? 'по' : 'до'} ${getActualSize(maxFileSize)}\n${acceptedFiles}`,
			]),
			viewTitle: title,
			viewIcon: ViewIcons.UPLOAD,
		}),
		[maxFilesCount, maxFileSize, acceptedFiles]
	)

	const reducer = useCallback<ReducerCallback>(
		(state, action) => {
			switch (action.type) {
				case 'file-upload': {
					return initialParams
				}
				case 'refresh': {
					return {
						...state,
						viewIcon: ViewIcons.REFRESH,
						viewTitle: 'Загрузить другой файл',
					}
				}
				case 'lock': {
					return {
						...state,
						viewIcon: ViewIcons.LOCK,
						viewTooltip: `Достигнут лимит загрузки: не более ${maxFilesCount} ${filesLabel(
							maxFilesCount
						)}.`,
						viewTitle: 'Загрузка недоступна',
					}
				}
				case 'custom': {
					return {
						...state,
						...action.payload,
					}
				}
				default: {
					// @ts-ignore
					throw new Error(`Unknown action ${action.type}`)
				}
			}
		},
		[maxFilesCount, initialParams]
	)

	const [viewParams, viewDispatch] = useReducer(reducer, initialParams)

	return {
		viewParams,
		viewDispatch,
	}
}
